import { WebsiteSource } from './WebsiteSource.mjs'
import { GenericSource } from './GenericSource.mjs'

export const researchSourceTypeClassMap = {
  website: WebsiteSource,
  generic: GenericSource,
}
